<template>
  <div>
  <enderecoModal ref="modalEndereco"/>
  <b-table
      :striped="true"
      :bordered="true"
      :hover="true"
      :responsive="true"
      table-variant="secondary"
      :fields="fields"
      :items="getEndereco"
      :busy="$store.getters['PTC_CadastroClienteClient/getIsLoadingEndereco']"
      show-empty
      empty-text="Nenhum registro encontrado"
  >
    <!-- A virtual column -->
    <template #table-busy>
      <div class="text-center text-primary my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Loading...</strong>
      </div>
    </template>
    <template #cell(clienteEnderecoseq)="data">
      <div class="text-nowrap">
        {{ data.item.clienteEnderecoseq}}
      </div>
    </template>

    <template #cell(tipoEnderecoid)="data">
      {{ data.item.tipoEnderecoid }}
    </template>

    <template #cell(endereco)="data">
      {{ data.item.clienteendereco}} - {{ data.item.clienteenderecobairro}} - {{ data.item.clienteenderecocidade}}
    </template>

    <template #cell(action)="data">
      <div
          class="d-flex"
          style="gap:5px"
      >
        <b-button
            variant="success"
            size="sm"
            @click="abrirModal('visualizar', data.item)"
            :hidden="$store.getters['PTC_CadastroClienteClient/getRequestChanges']"
        >
          <feather-icon icon="SearchIcon"/>
          <span>Visualizar</span>
        </b-button>
        <b-button
            variant="warning"
            size="sm"
            :hidden="$store.getters['PTC_CadastroClienteClient/getRequestChanges'] === false? true : false "
            @click="abrirModal('atualizar', data.item)"
        >
          <feather-icon icon="EditIcon"/>
          <span>editar</span>
        </b-button>
        <b-button
            variant="danger"
            size="sm"
            @click="confirmText(data.item)"
            :hidden="$store.getters['PTC_CadastroClienteClient/getRequestChanges'] === false? true : false"
        >
          <feather-icon icon="TrashIcon"/>
          <span>excluir</span>
        </b-button>
      </div>
    </template>
  </b-table>
    <b-row>
      <b-col>
        <b-button
            variant="gradient-primary"
            :hidden="$store.getters['PTC_CadastroClienteClient/getRequestChanges'] === false? true : false"
            @click="abrirModal('adicionar')"
        >
          <span class="align-middle">Adicionar Endereço</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { BFormSelect } from 'bootstrap-vue';
import enderecoModal from '@/views/app/PTC/CadastroCliente/endereco/enderecoModal.vue';
import PTC_CadastroClienteService from '@/services/PTC/PTC_CadastroCliente.service';
import { mapGetters } from 'vuex';

const ptc_CadastroClienteService = new PTC_CadastroClienteService();
export default {
  components: {
    enderecoModal,
    BFormSelect,
  },
  data() {
    return {
      fields: [
        { key: 'clienteEnderecoseq', label: 'Seq.' },
        { key: 'tipoEnderecoid', label: 'Tipo Endereço' },
        { key: 'endereco', label: 'Endereço' },
        { key: 'action', label: 'Ações' },
      ],
      items: [],
    };
  },

  methods: {
    abrirModal(tipoOperacao, dados) {
      this.$refs.modalEndereco.show(tipoOperacao, dados);
    },
    confirmText(item) {
      this.$swal({
        title: 'Tem certeza?',
        text: 'Você não poderá reverter isso!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, excluir!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteEndereco(item);
          // this.$swal({
          //   icon: 'success',
          //   title: 'Excluído!',
          //   text: 'O Endereço foi excluído com sucesso.',
          //   customClass: {
          //     confirmButton: 'btn btn-success',
          //   },
          // })
        }
      });
    },
    async deleteEndereco(item) {
      await ptc_CadastroClienteService.DeleteEnderecoCliente(item.clienteId, item.tipoEnderecoid);
      await ptc_CadastroClienteService.RetornaEnderecoCliente();
    },
  },
  computed: {
    ...mapGetters({
      getEndereco: 'PTC_CadastroClienteClient/getEndereco',
    }),
  },
};
</script>
<style scoped lang="scss">

</style>
